module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/housekeeping/views/logout.component.html
// module id = ./src/app/modules/housekeeping/views/logout.component.html
// module chunks = main